import { useSearchParams } from 'react-router-dom'
import { CreateAccountStep } from '@/components/registration/steps/CreateAccountStep'

export function RegisterPage() {
  const [searchParams] = useSearchParams()

  return <CreateAccountStep returnTo={searchParams.get('returnTo')} />
}
